import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from '@/hooks/useLanguage';
import { localPath } from '@/seo/meta.mjs';
import Navbar from '@/components/Navbar';
import WhatsAppButton from '@/components/WhatsAppButton';
import Footer from '@/components/Footer';
import RouteSEO from '@/components/RouteSEO';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ProductsPage from '@/pages/ProductsPage';
import ProductDetailPage from '@/pages/ProductDetailPage';
import WhyChoosePage from '@/pages/WhyChoosePage';
import ExportMarketsPage from '@/pages/ExportMarketsPage';
import ContactPage from '@/pages/ContactPage';
import AdminPage from '@/pages/AdminPage';
import LoginPage from '@/pages/LoginPage';
import AuthCallback from '@/pages/AuthCallback';
import BlogPage from '@/pages/BlogPage';
import BlogPostPage from '@/pages/BlogPostPage';
import LandingPage from '@/pages/LandingPage';
import NotFoundPage from '@/pages/NotFoundPage';
import usePageTracker from '@/hooks/usePageTracker';
import { useAttribution } from '@/hooks/useAttribution';
import '@/App.css';

const PUBLIC_ROUTES = [
  ['/', HomePage], ['/about', AboutPage], ['/products', ProductsPage], ['/products/:id', ProductDetailPage],
  ['/why-choose-us', WhyChoosePage], ['/export-markets', ExportMarketsPage], ['/contact', ContactPage],
  ['/blog', BlogPage], ['/blog/:slug', BlogPostPage], ['/market/:slug', LandingPage],
];

function AppLayout() {
  const location = useLocation();
  const isLogin = location.pathname === '/login';
  const isCallback = location.hash?.includes('session_id=');
  usePageTracker();
  useAttribution();

  // Auth callback must render before ProtectedRoute checks
  if (isCallback) {
    return <AuthCallback />;
  }

  return (
    <div className="min-h-screen bg-cream text-earth-dark font-sans">
      <RouteSEO />
      {!isLogin && <Navbar />}
      <Routes>
        {PUBLIC_ROUTES.flatMap(([path, Page]) => [
          <Route key={path} path={path} element={<Page />} />,
          <Route key={`hi${path}`} path={localPath(path, 'hi')} element={<Page />} />,
        ])}
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {!isLogin && <Footer />}
      {!isLogin && <WhatsAppButton />}
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LanguageProvider>
          <AppLayout />
        </LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
